// The owner's consent record: what they have agreed to, and the two ways to change it.
//
// Mirrors server/consent.js one-to-one, like every other module in this directory. Note
// the account-closure calls live here rather than in authApi.js, even though closure
// feels like an "account" operation: it IS a consent withdrawal (of the DPDP notice),
// the server implements it as one, and splitting it across two API modules would hide
// that from the next person reading either.
import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function getConsents() {
  const res = await apiFetch(`${API_BASE}/consent`);
  return res.json();
}

// `source` records WHERE the decision was made - 'profile' (this panel) or
// 'cookie_banner'. It is evidence, not routing: "they moved a toggle in their account
// settings" and "they ticked a box in a consent banner" are different facts about how
// consent was obtained, and the row should say which. The server validates it against an
// allowlist and falls back to 'profile', so a wrong value cannot fail a user's decision.
export async function withdrawConsent(purpose, source) {
  const res = await apiFetch(`${API_BASE}/consent/withdraw`, {
    method: 'POST',
    body: JSON.stringify({ purpose, ...(source ? { source } : {}) }),
  });
  return res.json();
}

export async function grantConsent(purpose, source) {
  const res = await apiFetch(`${API_BASE}/consent/grant`, {
    method: 'POST',
    body: JSON.stringify({ purpose, ...(source ? { source } : {}) }),
  });
  return res.json();
}

// `acknowledged` is not a formality the client can default to true. The server rejects
// the request without it (400 ACKNOWLEDGEMENT_REQUIRED), which is what makes "the
// consequences were shown first" a property of the system rather than a promise about
// this component - so it is passed explicitly, from a checkbox the user ticks after
// reading them.
export async function closeAccount(password, acknowledged) {
  const res = await apiFetch(`${API_BASE}/consent/close-account`, {
    method: 'POST',
    body: JSON.stringify({ password, acknowledged }),
  });
  return res.json();
}

export async function restoreAccount() {
  const res = await apiFetch(`${API_BASE}/consent/restore-account`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
  return res.json();
}
